import React from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import TenderList from "./TenderList";
import TenderListWithDetails from "./TenderListWithDetails";
import TenderListOfTiles from "./TenderListOfTiles";
import Tender from "./Tender";

export default function RenderingMode({mode}){
    
    if(mode === 1)
    {
        return ( 
            <Router>
                <Switch>
                    <Route path="/tender/:id" component={Tender} />
                    <Route component={TenderList} />
                </Switch>
            </Router>
        )
    }
    else if(mode === 2)
    {
        return ( 
            <Router>
                <Switch>
                    <Route path="/tender/:id" component={Tender} />
                    <Route component={TenderListWithDetails} />
                </Switch>
            </Router>
        )
    }
    else if(mode === 3)
    {
        return ( 
            <Router>
                <Switch>
                    <Route path="/tender/:id" component={Tender} />
                    <Route component={TenderListOfTiles} />
                </Switch>
            </Router>
        )
    }

    return (
        <div>            
        </div>
    )
}
